/**
 * 2019/1/9.
 * 作者:lzq
 *功能: 系统运行模块
 */
export default {
  $getway: 'sysapi',
  getSystemList: 'operation/list',
  getOperationDetail: 'operation/detail',
  saveSystem: 'operation/save',
  deleteSystem: 'operation/delete',
  updateSystemStatus: 'operation/open'
};
